import React from 'react';

const TemplateSelector = ({ templateList, onSelect }) => {
    return (
        <div className="py-2">
            <h5 className="mb-2 fw-bold text-dark">템플릿 선택</h5>
            <p className="text-secondary mb-4 small">
                업무 목적에 맞는 템플릿을 선택하세요.
            </p>

            <div className="row g-4">
                {templateList && templateList.length > 0 ? (
                    templateList.map((template) => (
                        <div key={template.uid} className="col-md-6 col-lg-4">
                            <div
                                className="card h-100 border-0 shadow-sm template-card position-relative overflow-hidden"
                                onClick={() => onSelect(template.uid)}
                                style={{
                                    cursor: 'pointer',
                                    transition: 'all 0.3s ease',
                                    backgroundColor: '#fff'
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'translateY(-5px)';
                                    e.currentTarget.style.boxShadow = '0 10px 20px rgba(0,0,0,0.1)';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = '0 .125rem .25rem rgba(0,0,0,.075)';
                                }}
                            >
                                <div className="card-body p-4 d-flex flex-column">
                                    <div className="d-flex align-items-center mb-3">
                                        <div className="icon-wrapper d-flex align-items-center justify-content-center bg-primary bg-opacity-10 text-primary rounded-3 me-3"
                                            style={{ width: '40px', height: '40px' }}>
                                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"></path>
                                                <polyline points="14 2 14 8 20 8"></polyline>
                                            </svg>
                                        </div>
                                        <h6 className="card-title fw-bold mb-0 text-dark" style={{ fontSize: '1.1rem' }}>
                                            {template.templateName}
                                        </h6>
                                    </div>

                                    <p className="card-text text-secondary mb-4 flex-grow-1" style={{ fontSize: '0.9rem', lineHeight: '1.5' }}>
                                        {template.titleTemplate}
                                    </p>

                                    {template.variables && template.variables.length > 0 && (
                                        <div className="mt-auto pt-3 border-top">
                                            <div className="d-flex align-items-center mb-2">
                                                <svg className="text-muted me-1" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path>
                                                    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path>
                                                </svg>
                                                <small className="text-secondary fw-semibold">입력 항목</small>
                                            </div>
                                            <div className="d-flex flex-wrap gap-2">
                                                {template.variables.map((variable, idx) => (
                                                    <span
                                                        key={idx}
                                                        className="badge bg-secondary bg-opacity-10 text-secondary border fw-normal px-2 py-1"
                                                    >
                                                        {variable}
                                                    </span>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))
                ) : (
                    <div className="col-12">
                        <div className="alert alert-light text-center py-5 border-0 bg-light rounded-3">
                            <div className="text-muted fs-5">사용 가능한 템플릿이 없습니다.</div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default TemplateSelector;
